var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVine8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2560 1440",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m1073.93,1685c-382.14,8.93 -694.64,-225 -766.07,-303.57c-71.43,-78.57 -239.29,-289.29 -180.36,-669.64c58.93,-380.36 466.07,-530.36 410.71,-298.21c-55.36,232.14 -57.14,364.29 -17.86,451.79c39.29,87.5 144.64,258.93 348.21,232.14c203.57,-26.79 489.29,-355.36 389.29,-578.57c-100,-223.21 -232.14,-246.43 -294.64,-382.14c-62.5,-135.71 -83.93,-594.64 251.79,-746.43c335.71,-151.79 650,69.64 757.14,178.57c107.14,108.93 226.79,371.43 247.5,722.14c20.71,350.71 -95.71,702.86 -257.14,810.71c-161.43,107.86 -226.07,51.07 -344.64,169.64c-118.57,118.57 -161.79,404.64 -543.93,413.57z",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_14",
    stroke: "#000000",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVine8);
export default __webpack_public_path__ + "static/media/vine8.29017f5dd47a568ef035322a6602ae4d.svg";
export { ForwardRef as ReactComponent };